/**
 * 고객 유형(역할) — 어드민 고객 관리 화면의 다중 선택이 쓰는 정본.
 *
 * 코드 값은 DB `CUSTOMER_ROLE.CODE` 와 같아야 한다(migrate_customer_role*.sql).
 * 조합 규칙은 서버(`CustomerRoleService.EXCLUSIVE_ROLE_PAIRS`)가 최종 강제하고,
 * 여기서는 선택지를 미리 잠가 잘못된 조합을 보내지 않게 한다.
 *   INFLUENCER + DEALER       가능
 *   INFLUENCER + DISTRIBUTOR  가능
 *   DEALER + DISTRIBUTOR      불가
 */
export type CustomerRoleCode = 'DEALER' | 'DISTRIBUTOR' | 'INFLUENCER'

export const CUSTOMER_ROLE_OPTIONS: { value: CustomerRoleCode; label: string }[] = [
	{ value: 'DEALER', label: 'Dealer' },
	{ value: 'DISTRIBUTOR', label: 'Distributor' },
	{ value: 'INFLUENCER', label: 'Influencer' },
]

/** 동시에 가질 수 없는 역할 쌍 */
export const EXCLUSIVE_CUSTOMER_ROLE_PAIRS: [CustomerRoleCode, CustomerRoleCode][] = [
	['DEALER', 'DISTRIBUTOR'],
]

/** 현재 선택(selected)이 있을 때 code 를 더 고를 수 있는가 */
export const isCustomerRoleSelectable = (code: string, selected: string[]): boolean => {
	if (selected.includes(code)) return true
	return !EXCLUSIVE_CUSTOMER_ROLE_PAIRS.some(
		([a, b]) =>
			(code === a && selected.includes(b)) || (code === b && selected.includes(a)),
	)
}

export const customerRoleLabel = (code: string): string =>
	CUSTOMER_ROLE_OPTIONS.find(aOption => aOption.value === code)?.label ?? code

/** 표시 순서 = CUSTOMER_ROLE_OPTIONS 순서. 목록·저장 전 비교에 같이 쓴다 */
export const sortCustomerRoles = (codes: string[]): string[] => {
	const order = CUSTOMER_ROLE_OPTIONS.map(aOption => aOption.value as string)
	return Array.from(new Set(codes)).sort((a, b) => {
		const ia = order.indexOf(a)
		const ib = order.indexOf(b)
		return (ia === -1 ? order.length : ia) - (ib === -1 ? order.length : ib)
	})
}
